import handlebars from 'handlebars';

export const translate = (locale,template,params={}) => {
  return handlebars.compile(template)(params);
};
